import type { BarButtonPort } from "../controls/bar/BarButtonPort";
import type { SpinCoordinator } from "../spin/SpinCoordinator";

/**
 * Manages the gamble entry button visibility and tap handling.
 *
 * Shows the button when `snapshot.canGamble` is true (post-win, idle).
 * Hides it when the player spins (forfeit) or enters gamble.
 * On tap → `spinCoordinator.enterGamble()`.
 */
export class GambleEntryPresenter {
  private unsubscribe?: () => void;

  public constructor(
    private readonly button: BarButtonPort,
    private readonly spinCoordinator: SpinCoordinator,
  ) {}

  public start(): void {
    this.button.setShown(false);
    this.button.setOnTap(() => {
      void this.spinCoordinator.enterGamble();
    });
    this.unsubscribe = this.spinCoordinator.subscribe((snap) => {
      this.button.setShown(snap.canGamble);
    });
  }

  public stop(): void {
    this.unsubscribe?.();
    this.unsubscribe = undefined;
    this.button.setOnTap(null);
    this.button.setShown(false);
  }
}
